type RouteParams = Record<string, string | string[] | undefined>;

function decodeSegment(segment: string): string {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}

// Reverse-maps param values onto pathname segments to recover the route
// template. Heuristic: a static segment whose text equals a param value is
// templated too — without the route manifest that ambiguity isn't resolvable
// client-side, and the output stays deterministic and low-cardinality anyway.
export function toRouteTemplate(pathname: string, params: RouteParams): string {
  const entries = Object.entries(params);
  if (entries.length === 0) return pathname;

  const rawSegments = pathname.split('/');
  const decoded = rawSegments.map(decodeSegment);
  const template: string[] = [];

  for (let i = 0; i < rawSegments.length; i += 1) {
    const single = entries.find(([, value]) => typeof value === 'string' && value === decoded[i]);
    if (single) {
      template.push(`[${single[0]}]`);
      continue;
    }

    const catchAll = entries.find(
      ([, value]) =>
        Array.isArray(value) &&
        value.length > 0 &&
        value.every((part, offset) => decoded[i + offset] === part)
    );
    if (catchAll) {
      template.push(`[...${catchAll[0]}]`);
      i += (catchAll[1] as string[]).length - 1;
      continue;
    }

    template.push(rawSegments[i]);
  }

  return template.join('/');
}
